import { Col, Row } from "antd";
import CustomCard from "../../../dentail-indetifcation/components/d-reusable/CustomCard";
import { assessmentIcons } from "../../utils/assessmentIcons";
import "./style.css";

// Partner logos - in a real app, these would be imported from files
const partnerLogos = {
  khalifa: "/placeholder.svg?height=150&width=200",
  twoFour54: "/placeholder.svg?height=150&width=200",
  pureElements: "/placeholder.svg?height=150&width=200",
};

function OurPartners() {
  return (
    <div className="our_partners_container">
      <div className="our_partners_body">
        <CustomCard>
          <div className="dental_id_info">
            <p>Dental ID Partner Program</p>
            <ul>
              <li>
                The age assessment model is an estimation of a person's
                chronological age, carried out through all possible scientifical
                means in cases where the age is unknown or in doubt.
              </li>
              <li>
                Research and Development contributed to the emergence of Dental
                iD, and the contribution of partners will be acknowledged on
                this page.
              </li>
            </ul>
          </div>
        </CustomCard>
        <br />
        <CustomCard>
          <div className="dental_id_partners">
            <p>Our Current Partners</p>
            <div className="dental_id_partners_section">
              <div className="dental_id_partner">
                <div className="dental_id_partner_logo">
                  <img
                    src={assessmentIcons.partner1}
                    alt="khalifa Innovation center"
                  />
                </div>
                <div className="dental_id_partner_info">
                  <p>Khalifa Innovation Center</p>
                  <span>Khalifa University, Abu Dhabi, UAE</span>
                </div>
              </div>
              <div className="dental_id_partner">
                <div className="dental_id_partner_logo">
                  <img
                    src={assessmentIcons.partner2}
                    alt="khalifa Innovation center"
                  />
                </div>
                <div className="dental_id_partner_info">
                  <p>TwoFour54</p>
                  <span>Media Zone Authority, Abu Dhabi, UAE</span>
                </div>
              </div>
              <div className="dental_id_partner">
                <div className="dental_id_partner_logo">
                  <img
                    src={assessmentIcons.partner3}
                    alt="khalifa Innovation center"
                  />
                </div>
                <div className="dental_id_partner_info">
                  <p>Pure Elements</p>
                  <span>Falcon House, Dubai, UAE</span>
                </div>
              </div>
            </div>
          </div>
        </CustomCard>
      </div>
    </div>
  );
}

export default OurPartners;
